import { handlePlaceholder, setAdvancedConfigToProps, } from '@/common/util/util';
import { CnRangeDatePickerPro, componentMap as formComponentMap, } from '@cainiaofe/cn-ui';
import { DisplayPosition } from '@/common/manager/position/display-position';
import React, { forwardRef, useEffect, useState } from 'react';
import { handleDisabledDate, handlePreset, requestDate, } from '@/common/manager/filter-item/date-picker/view';
import { handleBizExtendComponentProps } from '@/common/manager/plugin';
import isFunction from 'lodash/isFunction';
function RangePickerComposite(props) {
    const { disabledDate, getRequestParams, ...rest } = props;
    const extraProps = {};
    const [disabledDateList, setDisabledDateList] = useState();
    const [enabledDateList, setEnabledDateList] = useState();
    useEffect(() => {
        requestDate(disabledDate, getRequestParams)?.then((res) => {
            if (res) {
                const { key, list } = res;
                if (key === 'disabledDate') {
                    setDisabledDateList(list);
                }
                else if (key === 'enabledDate') {
                    setEnabledDateList(list);
                }
            }
        });
    }, []);
    extraProps.disabledDate = handleDisabledDate(disabledDate, disabledDateList, enabledDateList, getRequestParams);
    return <CnRangeDatePickerPro {...rest} {...extraProps}/>;
}
export const config = {
    position: [
        DisplayPosition.form,
        DisplayPosition.filter,
        DisplayPosition.formDialog,
        DisplayPosition.cnArrayTable,
        DisplayPosition.cnArraySubAreaCard,
    ],
    componentName: 'RangePicker',
    component: RangePickerComposite,
    formItemBeforeHandler: (formItem, config) => {
        const { urlParams, formValue, state } = config || {};
        if (formItem) {
            const componentProps = formItem['x-component-props'];
            if (componentProps) {
                componentProps.getRequestParams = () => {
                    return {
                        urlParamsDataSource: urlParams,
                        recordDataSource: formValue,
                        state,
                    };
                };
                handlePlaceholder(componentProps);
                handleBizExtendComponentProps(componentProps, 'CnRangeDatePickerPro');
                setAdvancedConfigToProps(componentProps);
            }
        }
    },
    filterItemBeforeHandler: (filterItemProps, config) => {
        const { componentProps, urlParamsDataSource, recordDataSource, state } = config || {};
        if (componentProps) {
            componentProps.getRequestParams = () => {
                return {
                    urlParamsDataSource,
                    recordDataSource,
                    state,
                };
            };
            handlePlaceholder(componentProps);
            setAdvancedConfigToProps(componentProps);
        }
    },
    formComponent: forwardRef((props, ref) => {
        const { disabledDate, getRequestParams, presetConfig, ...rest } = props;
        const extraProps = {};
        const [disabledDateList, setDisabledDateList] = useState([]);
        const [enabledDateList, setEnabledDateList] = useState([]);
        useEffect(() => {
            requestDate(disabledDate, getRequestParams)?.then((res) => {
                if (res) {
                    const { key, list } = res;
                    if (key === 'disabledDate') {
                        setDisabledDateList(list);
                    }
                    else if (key === 'enabledDate') {
                        setEnabledDateList(list);
                    }
                }
            });
        }, []);
        extraProps.disabledDate = handleDisabledDate(disabledDate, disabledDateList, enabledDateList, getRequestParams);
        if (presetConfig?.length > 0 || isFunction(presetConfig)) {
            extraProps.preset = handlePreset(presetConfig, getRequestParams);
        }
        return (<formComponentMap.CnRangeDatePickerPro {...rest} {...extraProps} ref={ref}/>);
    }),
};
